const objectToQuery = (object) => {
    let serialized = [];

    for (const key in object) {
        // let key = Object.keys(object)[k];
        const value = object[key];

        if(Array.isArray(value)){
            for(const val of value) {
                serialized.push(encodeURIComponent(key) + '[]=' + encodeURIComponent(val));
            }
        }
        else {
            serialized.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }

    }
    return serialized.join('&');
}

export default objectToQuery